<template>
  <thead>
    <slot></slot>
  </thead>
</template>

<script>
export default {
  name: "ChartHeader",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.chart-header {
}
</style>
